import { TPaginate, TResponseType } from '@@types/base';
import instance from '@apis/instance';
import { IMenuItems, IYogiyoMenu } from 'interfaces/menu';
import { IYogiyoAvgRating, IYogiyoReview } from 'interfaces/review';
import { IDiscountStore, IYogiyoStore } from 'interfaces/store';
import { headers } from 'next/headers';
import { invalidateGetResponse } from 'utils/common';

const BASE_STORE_URL = '/restaurant/store';

const fetchStores = (queryParams: Record<string, any>) =>
  invalidateGetResponse<TPaginate<IYogiyoStore>>({
    url: BASE_STORE_URL,
    options: { params: queryParams, headers: { requiredToken: true } },
  });

const BASE_RESTAURANT_URL = '/restaurant';

const fetchMenus = (
  restaurantId: string,
  { lat, lng }: { lat: string; lng: string },
) =>
  instance.get<TResponseType<IYogiyoMenu[]>>(`${BASE_RESTAURANT_URL}/menu`, {
    params: { id: restaurantId, lat, lng },
    headers: { requiredToken: true },
  });

const RESTAURANT_SEARCH_URL = `${BASE_STORE_URL}/search`;

const searchRestaurants = (queryParams: Record<string, any>) =>
  invalidateGetResponse<TPaginate<IYogiyoStore>>({
    url: RESTAURANT_SEARCH_URL,
    options: { params: queryParams, headers: { requiredToken: true } },
  });

const fetchRecommendedStores = async (latitude?: string, longitude?: string) =>
  invalidateGetResponse<IDiscountStore[]>({
    url: `${BASE_STORE_URL}/recommended`,
    options: {
      headers: { requiredToken: true },
      params: { lat: latitude, lng: longitude },
    },
  });

const fetchReviews = ({ id, page = '1' }: { id: string; page?: string }) =>
  invalidateGetResponse<IYogiyoReview[]>({
    url: `${BASE_RESTAURANT_URL}/review`,
    options: { params: { id, page }, headers: { requiredToken: true } },
  });

const fetchAverageRating = (storeId: string) =>
  invalidateGetResponse<IYogiyoAvgRating>({
    url: `${BASE_RESTAURANT_URL}/avgrating`,
    options: { params: { id: storeId }, headers: { requiredToken: true } },
  });

const fetchCachingMenus = (storeId: string) =>
  invalidateGetResponse<IYogiyoMenu[]>({
    url: `${BASE_RESTAURANT_URL}/${storeId}/menus`,
    options: { headers: { requiredToken: true } },
  });

const setCachingStore = (storeId: string, data: IYogiyoStore) =>
  instance.patch(`${BASE_RESTAURANT_URL}/cache/store/${storeId}`, data, {
    headers: { requiredToken: true },
  });
const fetchCachingStore = (storeId: string) =>
  instance.get(`${BASE_RESTAURANT_URL}/cache/store/${storeId}`, {
    headers: { requiredToken: true },
  });

const fetchDetailStore = (
  storeId: string,
  { lat, lng }: { lat: string; lng: string },
) =>
  instance.get(`${BASE_STORE_URL}/${storeId}`, {
    headers: { requiredToken: true },
    params: { lat, lng },
  });

export default {
  fetchStores,
  fetchMenus,
  searchRestaurants,
  fetchRecommendedStores,
  fetchReviews,
  fetchAverageRating,
  fetchCachingMenus,
  setCachingStore,
  fetchCachingStore,
  fetchDetailStore,
};
